import config from '@/config/prod.env';
import { header } from '@/helper/header';
import { common } from '@/helper/common';

export const nguonVonDauTuService = {
    GetBasicTree
};

async function GetBasicTree(params, tableName){
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };
    return await fetch(`${config.API_URL}/${tableName}/GetBasicTree`, requestOptions).then(response => common.handleResponse(response));
}